module.exports = __webpack_public_path__ + "static/media/tke.699ced6d.svg";